import { useQuery } from '@tanstack/react-query';

import AgreementsServiceClientImpl from 'src/api/agreementsService/client';
import { Building } from 'src/shared/types/building';

import { queryRetry } from '../query-retry';

export const useLicencePdfData = (building: Building) => {
    const slug = building.building_slug;
    return useQuery({
        queryKey: ['licence-pdf', slug],
        enabled: Boolean(slug),
        queryFn: async () => new AgreementsServiceClientImpl().getAgreementPdf(slug),
        select: (data) => `data:application/pdf;base64,${data}`,
        retry: queryRetry,
        staleTime: Infinity,
    });
};
